/* eslint-disable no-mixed-spaces-and-tabs */
import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';
import { initialState } from './reducer';

export const selectPlanningsProcessContainerDomain = state => state.planningsProcessContainerReducer || initialState;
export const selectRouterDomain = state => state.router || {};

export const getIsPlanningsProcessListLoadingSelector = () =>
	createSelector(
		selectPlanningsProcessContainerDomain,
		({ isPlanningsProcessListLoading }) => isPlanningsProcessListLoading,
	);

export const getPlanningsProcessListSelector = () =>
	createSelector(selectPlanningsProcessContainerDomain, ({ planningsProcessList }) => {
		if (!planningsProcessList || planningsProcessList.length === 0) {
			return [];
		}

		return planningsProcessList.map(planningsProcess => ({
			...planningsProcess,
		}));
	});

export const getIsProcessInfoLoadingSelector = () =>
	createSelector(selectPlanningsProcessContainerDomain, ({ isProcessInfoLoading }) => isProcessInfoLoading);

export const getProcessInfoSelector = () =>
	createSelector(selectPlanningsProcessContainerDomain, ({ processInfo }) => {
		return processInfo;
	});

export const getPaginationSelector = () =>
	createSelector(selectPlanningsProcessContainerDomain, ({ pagination }) => {
		if (!pagination || pagination?.total === 0) {
			return null;
		}

		return {
			currentPage: pagination.current_page,
			totalPages: pagination.last_page,
			perPage: pagination.per_page,
			total: pagination.total,
			from: pagination.current_page * pagination.per_page - (pagination.per_page - 1),
			to:
				pagination.current_page === pagination.last_page
					? pagination.total
					: pagination.current_page * pagination.per_page,
			isNextItem: true,
			isPrevItem: true,
			isLastItem: false,
			isFirstItem: false,
		};
	});

export const getConfigsSelector = () => createSelector(selectPlanningsProcessContainerDomain, ({ configs }) => configs);

export const getIsConfigsLoadingSelector = () =>
	createSelector(selectPlanningsProcessContainerDomain, ({ isConfigsLoading }) => isConfigsLoading);

export const getIsPlanningSelectedSelector = () =>
	createSelector(selectPlanningsProcessContainerDomain, ({ isPlanningSelected }) => isPlanningSelected);

export const getIsModalShownSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'plannings-process');
	});

export const getActiveProcessIdSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return query?.modal === 'plannings-process' ? query?.id : null;
	});

export const getIsCollectionListLoadingSelector = () =>
	createSelector(selectPlanningsProcessContainerDomain, ({ isCollectionListLoading }) => isCollectionListLoading);

export const getCollectionListSelector = () =>
	createSelector(selectPlanningsProcessContainerDomain, ({ collectionList }) => {
		if (!collectionList || isEmpty(collectionList)) {
			return [];
		}

		return collectionList.map(collection => ({
			...collection,
			region_from: collection.points[0]?.address?.region_with_type || '',
			address_from: collection.points[0]?.address || '',
			region_to: collection.points[1]?.address?.region_with_type || '',
			address_to: collection.points[1]?.address || '',
		}));
	});

export const getModesSelector = () => createSelector(selectPlanningsProcessContainerDomain, ({ modes }) => modes);

export const getIsModesLoadingSelector = () =>
	createSelector(selectPlanningsProcessContainerDomain, ({ isModesLoading }) => isModesLoading);

export const getPlanningOpenSelector = () =>
	createSelector(selectPlanningsProcessContainerDomain, ({ planningOpen }) => planningOpen);
